import { Theme, css } from '@emotion/react';
import styled from '@emotion/styled';

import type { BadgeType, BadgeSize } from './types';

const textColorStylesBadge: Record<BadgeType, 'dark' | 'light'> = {
  default: 'light',
  dark: 'light',
  light: 'dark',
  orange: 'dark',
  green: 'dark',
  'orange-gradient': 'dark',
  'green-gradient': 'dark',
};

const mapColor = (theme: Theme, color: BadgeType = 'default') =>
  ({
    default: theme.colors.neutral.grey140!,
    dark: theme.colors.neutral.grey160,
    light: theme.colors.neutral.white100,
    orange: theme.colors.brand.orange100,
    green: theme.colors.brand.green100,
    'orange-gradient': theme.colors.brand.orange100,
    'green-gradient': theme.colors.brand.green100,
  })[color];

const Wrapper = styled.span<{
  badgeType: BadgeType;
  badgeSize: BadgeSize;
  hasIcon: boolean;
}>`
  ${({ hasIcon }) =>
    hasIcon
      ? css`
          display: inline-flex;
          flex-wrap: nowrap;
          gap: 0.5rem;
          align-items: center;
        `
      : css`
          display: inline-block;
        `};
  ${({ theme, badgeSize }) =>
    badgeSize === 'small'
      ? css`
          padding: 0.125rem 0.25rem;
          border-radius: ${theme.radius.xs};
          font-size: 0.875rem;
        `
      : css`
          padding: 0.25rem 1rem;
          border-radius: ${theme.radius.round};
          font-size: 1rem;
        `};
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
  line-height: 1.5;
  fill: currentcolor;
  color: ${({ theme, badgeType }) =>
    mapColor(theme, textColorStylesBadge[badgeType])};
  background-color: ${({ theme, badgeType }) => mapColor(theme, badgeType)};
  background-image: ${({ theme, badgeType }) => {
    switch (badgeType) {
      case 'orange-gradient':
        return theme.linearGradient(theme.gradient.orange, 'to left');
      case 'green-gradient':
        return theme.linearGradient(theme.gradient.green, 'to left');
      default:
        return '';
    }
  }};

  ${({ theme, badgeSize }) =>
    badgeSize !== 'small' &&
    css`
      ${theme.mq('lg')} {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
      }
    `}
`;

export { Wrapper };
